export default "__VITE_ASSET__CfUD09Pv__"